var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFooterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 16,
    fill: "#4D4792"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3334 29.081C43.3334 21.6721 37.3645 15.6667 30.0001 15.6667C22.6356 15.6667 16.6667 21.6721 16.6667 29.081C16.6667 35.7779 21.5414 41.3272 27.9165 42.3334V32.9592H24.5316V29.0801H27.9165V26.1254C27.9165 22.7636 29.9067 20.9059 32.953 20.9059C34.4107 20.9059 35.9379 21.1681 35.9379 21.1681V24.4694H34.2552C32.5992 24.4694 32.0836 25.5041 32.0836 26.5654V29.081H35.7814L35.1903 32.9583H32.0836V42.3334C38.4587 41.3272 43.3334 35.7779 43.3334 29.081Z",
    fill: "#DB68A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooterIcon);
export default __webpack_public_path__ + "static/media/facebookFooterIcon.b9bb5ab5fe848786205e2ddb7e54924f.svg";
export { ForwardRef as ReactComponent };